/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.20.0
 */

export const utoa = (str: string) => {
    return window.btoa(unescape(encodeURIComponent(str)));
};

export const atou = (str: string) => {
    try {
        return decodeURIComponent(escape(window.atob(str)));
    } catch (e) {
        return str;
    }
};
